exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mOorf{margin:.5em}.IzVTi,.mOorf{display:inline-block}.IzVTi{height:45px;width:45px;border-radius:45px;line-height:45px;text-align:center;background:linear-gradient(180deg,#7d7e7d 20%,#565656);text-shadow:rgba(0,0,0,.3) 1px 1px 0;box-shadow:0 1px 5px rgba(0,0,0,.2);margin-right:.5em}._2Uy49{background:#7d7e7d}.V35SU{background:linear-gradient(180deg,#f9c667 0,#f79621)}._2xPg_{background:#f8a50a}._1-zUU{background:linear-gradient(180deg,#a4b357 0,#75890c)}._1hMQ2{background:#81941f}._3FWyS{margin-bottom:-5px}._2p1mm{font-weight:300}._2eqYQ,._2p1mm{color:#706d6d;font-size:.8em;padding:.1em}._2eqYQ{font-weight:700}.I78Jt{display:inline-block}", ""]);

// exports
exports.locals = {
	"item": "mOorf",
	"number": "IzVTi",
	"itemFlatNumber": "_2Uy49",
	"activeItemNumber": "V35SU",
	"activeFlatItemNumber": "_2xPg_",
	"doneItemNumber": "_1-zUU",
	"doneFlatItemNumber": "_1hMQ2",
	"arrow": "_3FWyS",
	"text": "_2p1mm",
	"status": "_2eqYQ",
	"labels": "I78Jt"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&localIdentName=[hash:base64:5]!./~/less-loader!./lib/types/Circle.less
 ** module id = 7
 ** module chunks = 0
 **/